import { Container, Row, Col, Card } from "react-bootstrap";
import AboutUsImage from "../assets/about-us.png"

export default function AboutUs() {
    return (
        <section className="about-section">
            <Container>
                <div className="text-center mb-5">
                    <h2 className="section-title">About Us</h2>
                </div>
                <Row className="mb-5 company-details align-items-center">
                    <Col lg={6}>
                        <img
                            src={AboutUsImage}
                            alt="About RR Shipping & Logistics"
                            className="img-fluid rounded-4 shadow"
                        />
                    </Col>

                    <Col lg={6}>
                        <p>
                            RR Shipping & Logistics is a customer-focused logistics partner
                            providing end-to-end solutions across customs clearance,
                            transportation, and freight forwarding. We simplify complex
                            supply chains by combining industry expertise with operational
                            excellence.
                        </p>
                        <p>
                            Our commitment to compliance, transparency, and timely delivery
                            enables businesses to move goods across borders with confidence.
                        </p>
                    </Col>
                </Row>

                <Row className="g-4 mb-5">
                    <Col md={4}>
                        <Card className="vision-card">
                            <Card.Body>
                                <h4 className="card-title">Our Vision</h4>
                                <p>
                                    To be a globally trusted logistics partner, empowering
                                    businesses through innovative, efficient, and sustainable
                                    supply chain solutions.
                                </p>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col md={4}>
                        <Card className="mission-card">
                            <Card.Body>
                                <h4 className="card-title">Our Mission</h4>
                                <p>
                                    To deliver seamless logistics services by leveraging
                                    technology, expertise, and a customer-first approach, while
                                    consistently exceeding expectations in reliability and
                                    service quality.
                                </p>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col md={4}>
                        <Card className="values-card">
                            <Card.Body>
                                <h4 className="card-title">Our Values</h4>
                                <p>
                                    Reliability, Global Mindset, Operational Excellence, Transparency, Customer-Centric Approach
                                </p>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}
